// Redux
import { useSelector } from "react-redux";

// Icons
import HolderImageUser from "@/assets/icons/svg/HolderImageUser";
import QuestionMarkRoundedIcon from "@mui/icons-material/QuestionMarkRounded";

function ImageContainer(props) {
	const { src, width, style, className, imageDefaults, iconColor, onClick, onMouseLeave, onMouseOver } = props;

	switch (src) {
		case "Unknown":
			return <QuestionMarkRoundedIcon style={{ ...style, color: iconColor }} className={className} />;
		case "Holder":
			return <HolderImageUser {...imageDefaults} />;
		default:
			break;
	}

	return (
		<img
			src={src}
			alt={"User profile"}
			crossOrigin="true"
			width={width}
			style={style || {}}
			className={className || ""}
			onClick={onClick}
			onMouseLeave={onMouseLeave}
			onMouseOver={onMouseOver}
		/>
	);
}

export default function ImageUserProfilePicture(props) {
	const user = useSelector((state) => state.user.user);

	return (
		<>
			{props.context === "edit" && (
				<ImageContainer
					src={props?.src || "Holder"}
					style={props.style || {}}
					className={props.className || ""}
					imageDefaults={{
						widthImgHolder: props.widthImgHolder,
						heightImgHolder: props.heightImgHolder,
						fillImgHolder: props.fillImgHolder,
						classNameHolder: props.classNameHolder,
					}}
					onClick={props.handleClick}
					onMouseLeave={props.onMouseLeave}
					onMouseOver={props.onMouseOver}
				/>
			)}

			{props.context === "single" && (
				<ImageContainer
					src={props?.src || user?.profilePicture || "Holder"}
					width={props.widthImg || "100%"}
					style={props.style || {}}
					className={props.className || ""}
					imageDefaults={{
						widthImgHolder: props.widthImgHolder,
						heightImgHolder: props.heightImgHolder,
						fillImgHolder: props.fillImgHolder,
						classNameHolder: props.classNameHolder,
					}}
					onClick={props?.handleClick}
					onMouseLeave={props?.onMouseLeave}
					onMouseOver={props?.onMouseOver}
				/>
			)}

			{props.context === "multiple" && (
				<ImageContainer
					src={props?.src || "Holder"}
					width={props.widthImg || "5px"}
					style={props.style || {}}
					className={props.className || ""}
					iconColor={props.iconColor}
					imageDefaults={{
						widthImgHolder: props.widthImgHolder,
						heightImgHolder: props.heightImgHolder,
						fillImgHolder: props.fillImgHolder,
						classNameHolder: props.classNameHolder,
					}}
					onClick={props?.handleClick}
					onMouseLeave={props?.onMouseLeave}
					onMouseOver={props?.onMouseOver}
				/>
			)}
		</>
	);
}
